import { ExpectedError } from "../../expectedError";

export function endpoint({ host, port }: Record<string, string>) {
  const hostname = (host ?? "").trim();
  if (
    !/^[A-Za-z0-9.-]+$/.test(hostname) &&
    !/^\[[0-9a-fA-F:]+\]$/.test(hostname)
  ) {
    throw new ExpectedError("Invalid VNC host");
  }
  const value = port || "5900";
  if (!/^\d+$/.test(value) || Number(value) < 1 || Number(value) > 65535) {
    throw new ExpectedError("Invalid VNC port");
  }
  return new URL(`vnc://${hostname}:${value}`).href;
}

export function publicEnvVars(configuration: Record<string, string>) {
  const url = new URL(endpoint(configuration));
  return {
    VNC_HOST: url.hostname.replace(/^\[|\]$/g, ""),
    VNC_PORT: url.port,
    VNC_URL: url.href,
  };
}

export const CLIENT_CONTEXT =
  "Workflow code receives VNC_HOST, VNC_PORT, and VNC_URL, never the password. Connect a standard RFB 3.8 client without credentials: the proxy offers security type None only after authenticating upstream. Python vncdotool can capture screenshots and send keyboard and pointer events. Use a tunnel for private hosts. This connector provides authentication, not a desktop viewer or an image-returning chat tool.";

export function usageHint() {
  return "Connect to VNC_HOST:VNC_PORT without a password. The proxy authenticates upstream and presents RFB security type None to the workflow client. With vncdotool, use api.connect(f'{host}::{port}') without a password argument.";
}
